/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Unpaid_InvoiceInputs */

const en_admin_dashboard_unpaid_invoice = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpaid Invoice`)
};

const de_admin_dashboard_unpaid_invoice = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbezahlte Rechnung`)
};

const es_admin_dashboard_unpaid_invoice = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factura por pagar`)
};

const fr_admin_dashboard_unpaid_invoice = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facture non payée`)
};

const nl_admin_dashboard_unpaid_invoice = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onbetaalde factuur`)
};

const it_admin_dashboard_unpaid_invoice = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fattura non pagata`)
};

const pt_br2_admin_dashboard_unpaid_invoice = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatura não paga`)
};

const pl_admin_dashboard_unpaid_invoice = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niezapłacona faktura`)
};

const hu_admin_dashboard_unpaid_invoice = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kifizetetlen számla`)
};

const ro_admin_dashboard_unpaid_invoice = /** @type {(inputs: Admin_Dashboard_Unpaid_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factura Neplatita`)
};

/**
* | output |
* | --- |
* | "Unpaid Invoice" |
*
* @param {Admin_Dashboard_Unpaid_InvoiceInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_unpaid_invoice = /** @type {((inputs?: Admin_Dashboard_Unpaid_InvoiceInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Unpaid_InvoiceInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_unpaid_invoice(inputs)
	if (locale === "de") return de_admin_dashboard_unpaid_invoice(inputs)
	if (locale === "es") return es_admin_dashboard_unpaid_invoice(inputs)
	if (locale === "fr") return fr_admin_dashboard_unpaid_invoice(inputs)
	if (locale === "nl") return nl_admin_dashboard_unpaid_invoice(inputs)
	if (locale === "it") return it_admin_dashboard_unpaid_invoice(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_unpaid_invoice(inputs)
	if (locale === "pl") return pl_admin_dashboard_unpaid_invoice(inputs)
	if (locale === "hu") return hu_admin_dashboard_unpaid_invoice(inputs)
	return ro_admin_dashboard_unpaid_invoice(inputs)
});
export { admin_dashboard_unpaid_invoice as "admin.dashboard.unpaid_invoice" }